import type { ReferenceRecord } from "../../../components/reference/types";
import { api } from "../http";
import { buildReferenceCacheKey, isNavigatorOffline, searchCachedReferences } from "../../offline/referenceCache";

export type OutbreakReferenceType = "drill-types";

const prefixFor = (type: OutbreakReferenceType) => buildReferenceCacheKey("outbreak", type);

function path(type: OutbreakReferenceType) {
  return `/api/outbreak/references/${type}`;
}

export const outbreakReferencesApi = {
  async search(type: OutbreakReferenceType, params: { q?: string; limit?: number } = {}) {
    if (isNavigatorOffline()) {
      const cached = await searchCachedReferences(prefixFor(type), params);
      if (cached) return cached;
    }
    try {
      const query = Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== "")
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join("&");
      return await api.get<ReferenceRecord[]>(`${path(type)}${query ? `?${query}` : ""}`);
    } catch (error) {
      const cached = await searchCachedReferences(prefixFor(type), params);
      if (cached) return cached;
      throw error;
    }
  },
  async create(type: OutbreakReferenceType, payload: Record<string, string | undefined>) {
    return api.post<ReferenceRecord, Record<string, string | undefined>>(path(type), payload);
  },
  async update(type: OutbreakReferenceType, id: string, payload: Record<string, string | undefined>) {
    return api.put<ReferenceRecord, Record<string, string | undefined>>(
      `${path(type)}/${encodeURIComponent(id)}`,
      payload,
    );
  },
};

export default outbreakReferencesApi;
